import component from "./Contact"

export default { 
    component, 
    urlHash: "#contact",
}